
import { defineComponent } from "vue";
import SvgIcon from "@jamescoyle/vue-icon";

export default defineComponent({
  name: "SuggestionLink",
  components: { SvgIcon },
  props: {
    value: { required: true },
    typeKey: { type: String, required: true },
    iconPath: { type: String, default: "" },
  },
  emits: ["select"],
  methods: {
    handleClick() {
      this.$emit("select", { value: this.value, typeKey: this.typeKey });
    },
  },
});
